import { Routes, Route, HashRouter } from "react-router-dom";
import Footer from "./components/Footer";
import Header from "./components/Header";
import QuoteForm from "./components/QuoteForm";
import ScrollToTop from "./components/ScrollToTop";
import TopNav from "./components/TopNav";
import AboutPage from "./pages/AboutPage";
import Construction from "./pages/Construction";
import Contact from "./pages/Contact";
import ElectricalServices from "./pages/ElectricalServices";
import FireSystemService from "./pages/FireSystemService";
import Home from "./pages/Home";
import IctIot from "./pages/IctIot";
import Projects from "./pages/Projects";

function App() {
  return (
    <HashRouter>
      <TopNav />
      <Header />
      <ScrollToTop />
      <Routes>
        <Route path="/" element={<Home />} />
        <Route path="/about" element={<AboutPage />} />
        <Route path="/construction" element={<Construction />} />
        <Route path="/ict" element={<IctIot />} />
        <Route path="/projects" element={<Projects />} />
        <Route path="/electrical" element={<ElectricalServices />} />
        <Route path="/fire" element={<FireSystemService />} />
        <Route path="/contact" element={<Contact />} />
        <Route path="/quote" element={<QuoteForm />} />
      </Routes>
      <Footer />
    </HashRouter>
  );
}

export default App;
